import { defineStore } from 'pinia';
import workflowApi from '@/api/workflowApi.js';

function key(entity, id) {
    return `${entity}:${Number(id) || 0}`;
}

export const useWorkflowStore = defineStore('workflowStore', {
    state: () => ({
        // Кеш по сущности: { ["work:12"]: { current_state, available } }
        availableByKey: {},
        // История переходов по сущности
        historyByKey: {},
        loading: false,
    }),
    getters: {
        currentState: (s) => (entity, id) => s.availableByKey[key(entity, id)]?.current_state || null,
        availableStates: (s) => (entity, id) => s.availableByKey[key(entity, id)]?.available || [],
        history: (s) => (entity, id) => s.historyByKey[key(entity, id)] || [],
    },
    actions: {
        async loadAvailable(entity, id) {
            if (!entity || !id) return { current_state: null, available: [] };
            this.loading = true;
            try {
                const data = await workflowApi.getAvailableTransitions(entity, id);
                this.availableByKey[key(entity, id)] = data || { current_state: null, available: [] };
                return data;
            } finally {
                this.loading = false;
            }
        },
        async loadHistory(entity, id) {
            if (!entity || !id) return [];
            const list = await workflowApi.getStatusHistory(entity, id);
            this.historyByKey[key(entity, id)] = Array.isArray(list) ? list : [];
            return this.historyByKey[key(entity, id)];
        },
        async transition(entity, id, { to_state, reason } = {}) {
            if (!entity || !id || !to_state) return;
            await workflowApi.doTransition(entity, id, { to_state, reason });
            await this.loadAvailable(entity, id);
        }

    },
});